// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--pmczJ","wrapper":"a10a3f92e9--wrapper--K3gL_","title":"a10a3f92e9--title--PgnyK"};